import { settings, useSetting } from '../settings';

export const useMsTeamsAvailable = (): boolean => {
  return useSetting(settings.msTeamsAvailable()).value === 'True';
};
